import script from "./CrowdfundingIlot.vue?vue&type=script&setup=true&lang=js"
export * from "./CrowdfundingIlot.vue?vue&type=script&setup=true&lang=js"

import "./CrowdfundingIlot.vue?vue&type=style&index=0&id=522f20fe&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-522f20fe"]])

export default __exports__